<template>
  <v-card class="rounded-card elevation-10" >
    <v-sheet
      class="gradient"
    >
      <v-container fill-height fluid pl-4 pa-2>
        <v-layout fill-height>
          <span class="text-h6 white--text font-weight-light">Selection from Member Galleries</span>
        </v-layout>
      </v-container>
    </v-sheet>
    <a v-if="isExhibition == 0" :href="'#/lightbox/gallery/' + galleryID + '/0'">
      <v-img contain max-height="90vh"
        :src="imageURL"
      >
      </v-img>
    </a>
    <a v-else target="_new" :href="'/slideshow/index.html?id=' + galleryID">
      <v-img contain max-height="90vh"
        :src="imageURL"
      >
      </v-img>
    </a>
    <div v-if="comments != ''" class="caption text-center">
      {{comments}}
      <span v-if="isExhibition == 1">© {{photographer}}</span>
    </div>
    <div v-else class="caption text-center">&copy; {{photographer}}</div>
    <LikePhoto :imageID="imageID" :likes="$store.state.meetingInfo.randomGalleryLikes"/>
    <v-card-text>
      <div v-if="isExhibition == 0" class="black--text body-2">
        From the <a :href="'#/lightbox/gallery/' + galleryID + '/0?redirect=/'">{{galleryName}}</a>
        gallery of {{photographer}}
      </div>
      <div v-else>
        From the <a target="_new" :href="'/slideshow/index.html?id=' + galleryID">{{galleryName}}</a>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import LikePhoto from '@/components/LikePhoto'

export default {
  name: 'RandomGalleryCard',
  components: {
    LikePhoto,
  },
  props: {
    imageURL: String,
    galleryName: String,
    photographer: String,
    isExhibition: Number,
    galleryID: Number,
    comments: String,
    imageID: Number,
  },
  computed: {
    website: function () {
      return process.env.VUE_APP_WEBSITE
    }
  },
}
</script>

<style scoped>
.rounded-card {
  border-radius: 7px;
}
.gradient {
  background: linear-gradient(180deg, #555555 0%,#555555 100%);
}
</style>
